import React, { useEffect, useState } from 'react';
import { trackEvent } from '../utils/analytics';
import { ANALYTICS_EVENTS } from '../utils/analyticsEvents';
import { buildAppUrl } from '../utils/appLinks';

export default function MobileAppCTA() {
  const [isVisible, setIsVisible] = useState(true);
  const appLink = buildAppUrl({
    medium: 'mobile_floating',
    location: 'mobile_floating_cta',
  });

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const updateVisibility = () => {
      const consent = window.localStorage.getItem('cookieConsent');
      setIsVisible(Boolean(consent));
    };
    const hideOnOpen = () => setIsVisible(false);

    updateVisibility();
    window.addEventListener('cookie-consent:open', hideOnOpen);
    window.addEventListener('cookie-consent:updated', updateVisibility);

    return () => {
      window.removeEventListener('cookie-consent:open', hideOnOpen);
      window.removeEventListener('cookie-consent:updated', updateVisibility);
    };
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <a
      href={appLink}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => {
        trackEvent(ANALYTICS_EVENTS.APP_OPEN_CLICK, {
          location: 'mobile_floating_cta',
          outbound: true,
        });
      }}
      className="md:hidden fixed bottom-6 left-4 z-40 inline-flex items-center gap-2 rounded-full bg-[#2d2b29] px-4 py-3 text-[11px] uppercase tracking-[0.22em] text-[#f5f4f2] shadow-lg hover:bg-[#1f1d1b] transition-colors"
      aria-label="Open SistaKyerewaa App"
    >
      Open App
    </a>
  );
}
